import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../Common/Header';
import Footer from '../Common/Footer';

const PresentationPage = () => {
  const { t } = useTranslation();
  return (
    <>
    <Header />
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <div
          style={{
            position: 'relative',
            width: '100%',
            height: 0,
            paddingTop: '56.2500%',
            paddingBottom: 0,
            boxShadow: '0 2px 8px 0 rgba(63,69,81,0.16)',
            marginTop: '1.6em',
            marginBottom: '0.9em',
            overflow: 'hidden',
            borderRadius: '8px',
            willChange: 'transform',
          }}
        >
          <iframe
            loading="lazy"
            style={{
              position: 'absolute',
              width: '100%',
              height: '100%',
              top: 0,
              left: 0,
              border: 'none',
              padding: 0,
              margin: 0,
            }}
            src="https://www.canva.com/design/DAGcmjmVtgQ/uFQ92noryzC2N-dT54j-rg/view?embed"
            allowfullscreen="allowfullscreen"
            allow="fullscreen"
          ></iframe>
        </div>
        <a
          target="_blank"
          rel="noopener"
        >
          {t('pages.presentation.linkText')}
        </a>
      </div>
      <Footer />
      </>
  );
};

export default PresentationPage;
